import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useEcusModuleStore = defineStore('ecus-module', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const ecuModules        = ref({ array: [] })
    const ecuModulesProcess = ref(false)
    const ecuModulesMsg     = ref('')

    /**
     * Получает информацию о модулях автомобиля [не путать с ЭБУ!]
     * 
     * @param {String} payload - параметры запроса [см.swagger]
     */
    async function readEcuModules(payload) {

        ecuModulesProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/modules${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                request.array.map(module => {
                    let name = ''
                    if(module.moduleType == 1) name = 'ECU_MODULES_MAIN'
                    if(module.moduleType == 5) name = 'ECU_MODULES_INTERFACE'
                    if(module.moduleType == 7) name = 'ECU_MODULES_BOOTLOADER'
                    module.name = name
                })
                ecuModules.value = request
                ecuModulesMsg.value = { success: true }
            } else {
                ecuModulesMsg.value = { success: false, text: request.error }
            }

        } else {
            ecuModulesMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        ecuModulesProcess.value = false
    }

    const resetModules = () => {

        ecuModules.value           = { array: [] }
        ecuModulesProcess.value    = false
        ecuModulesMsg.value        = ''
    }

    return {

        ecuModules,
        ecuModulesProcess,
        ecuModulesMsg,
        readEcuModules,
        resetModules
    }
})
